import { render, staticRenderFns } from "./TransactionListItem.vue?vue&type=template&id=874185f8&scoped=true&"
import script from "./TransactionListItem.vue?vue&type=script&lang=ts&"
export * from "./TransactionListItem.vue?vue&type=script&lang=ts&"
import style0 from "./TransactionListItem.vue?vue&type=style&index=0&id=874185f8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "874185f8",
  null
  
)

export default component.exports